/**
 * @module components\ghInvoke
 */
import Vue from "vue";
import { Component, Prop, Watch, Model } from "vue-property-decorator";
import { MethodService } from "./../../utils/serviceModel";

@Component
export default class GhInvoke extends Vue {
  @Model("change") readonly data!: IResData;

  @Prop({ default: true })
  private isIntial!: boolean;
  @Prop()
  private readonly module!: string;
  @Prop()
  private readonly cls!: string;
  @Prop()
  private readonly method!: string;
  @Prop()
  public args!: object;

  private loading = false;

  private methodService: MethodService;

  private items: any = [];

  public get Result() {
    return this.items;
  }

  created() {
    this.methodService = new MethodService(this.module, this.cls, this.method);
  }

  mounted() {
    if (this.isIntial) {
      this.invoke();
    }
  }

  public invoke(args?: object) {
    this.invokeAsync(args);
  }

  public async invokeAsync(args?: object) {
    let argument = args;

    if (!args) {
      argument = this.args;
    }
    this.$emit("start");
    this.loading = true;
    let res;
    try {
      res = await this.methodService.invokeAsyn(argument);
      if (res.data.isSuccess) {
        this.items = this.methodService.data;
      } else {
        this.items = [];
      }
    } catch (error) {
      this.items = [];
    } finally {
      this.loading = false;
      this.$emit("change", this.items);
      this.$emit("complete", this.items);
    }
    return res;
  }
}
